import { windowAvailable } from '~/utils/client-detection';

const STAGE_PARAMETER = windowAvailable()
	? (new URLSearchParams(window?.location.search).get('stage')?.toLowerCase() ?? '')
	: '';

export default function isConsFinancingStage() {
	return STAGE_PARAMETER === 'int';
}
